export default class JfBreadcrumbsWrapperComponent {
    constructor() {
        this.template = `<div ng-non-bindable id="ng-jf-breadcrumbs-wrapper"></div>`;
        this.controller = JfBreadcrumbsWrapperController;
        this.bindings = {
            items: '<'
        };
    }
}

class JfBreadcrumbsWrapperController {
    constructor() {

    }

    $onInit() {
        const itemsRef = this.items;

        const template = `<jf-breadcrumbs
                :items="items">                
            </jf-breadcrumbs>`;

        new Vue({
            el: '#ng-jf-breadcrumbs-wrapper',
            template,
            router: $vueRouter,
            data() {
                return {
                    items: itemsRef
                };
            }
        });
    }
}



// WEBPACK FOOTER //
// ./ui_components/jf_breadcrumbs_wrapper/js.breadcrumbs.wrapper.component.js